// extracted by css-extract-rspack-plugin
export default {"cls1":"LogoCell-cls1_guA","cls2":"LogoCell-cls2_Do0 LogoCell-cls1_guA"};